














import Vue from 'vue'
import {Dictionary} from 'vuex'
import StudentsActiveTableConfig from '@/activeTables/Students/FullList'
import activeTable from '@/components/Ui/ActiveTable/ActiveTable.vue'
import store from '@/store'
import {setSessStoreItem, getSessStoreItem} from '@/services/sessionStorageTransfer'
import bus from '@/services/bus'

export default Vue.extend({
  name: 'studentsList',
  components: {
    activeTable
  },
  data () {
    return {
      config: {},
      loaded: false,
      defaultFilters: {},
      defaultSort: {}
    }
  },
  methods: {
    onFiltersChanged (filters: Dictionary<any>) {
      setSessStoreItem('studListFilters', filters)
    },
    onSortChanged (sort: Dictionary<1 | -1>) {
      setSessStoreItem('studListSort', sort)
    },
    setDefaultSort () {
      const sort = getSessStoreItem('studListSort');
      if (sort) {
        this.defaultSort = sort;
      }
    },
    setDefaultFilters () {
      const filters = getSessStoreItem('studListFilters');
      if (filters) {
        this.defaultFilters = filters;
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    // @ts-ignore
    await StudentsActiveTableConfig.loadFiltersValues()
    // @ts-ignore
    bus.$emit('pathChanged')
    next();
  },
  async mounted () {
    await this.setDefaultFilters()
    await this.setDefaultSort()
    this.config = StudentsActiveTableConfig
    this.loaded = true
  }
})
